<template>
  <a-card :title="sourceData.team_name" size="small" :bordered="false">
    <div :id="`task-detail-${sourceData.team_id}`" :style="{ height: height, width: width }" />
  </a-card>
</template>
<script>
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    sourceData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: {},
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18
          }
        ]
      },
      xAxisData: [],
      series: []
    };
  },
  watch: {
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    this.myChart = echarts.init(document.getElementById(`task-detail-${this.sourceData.team_id}`));
    this.option.series = [
      {
        type: 'bar',
        label: {
          show: true,
          position: 'top'
        },
        name: '任务点数',
        data: this.sourceData.point_count_series
      },
      {
        type: 'bar',
        label: {
          show: true,
          position: 'top'
        },
        name: '任务数',
        data: this.sourceData.task_count_series
      }
    ];
    this.option.xAxis.data = this.sourceData.x_axis;
    this.drawChart();
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
</style>
